import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import { AnalyticsAttributesProvider, Column, Expand, Markdown, Row, useAnalytics, useAnalyticsAttributes } from '../../components';
import { AccordionButton, GridItem, GridItemContent, List, ListItem, ListItemContent } from './UiAccordion.styles';
export default function UiAccordion({ model: { type, content: { title, items, appearance, background } } }) {
    const parentTitle = title;
    const [openKeys, setOpenKeys] = useState([]);
    const [trackedKeys, setTrackedKeys] = useState([]);
    const history = useHistory();
    const { sendTrackEvent } = useAnalytics();
    const analyticsAttributes = useAnalyticsAttributes();
    useEffect(() => {
        setOpenKeys(window.location.hash
            .slice(1)
            .split(',')
            .filter((key) => key));
    }, []);
    const toggleOpenKeys = (id, title, entryTitle, parentTitle) => {
        const newOpenKeys = [...openKeys.filter((key) => id !== key)];
        if (!openKeys.includes(id)) {
            newOpenKeys.push(id);
            if (!trackedKeys.includes(id)) {
                sendTrackEvent('expandedAccordionItem', Object.assign(Object.assign({}, analyticsAttributes), { event: 'expanded', eventComponent: 'accordion', eventContainer: type, uuid: id, label: title, labelEnglish: entryTitle, parentLabel: parentTitle }));
                setTrackedKeys([...trackedKeys, id]);
            }
        }
        history.push(`#${newOpenKeys.join()}`);
        setOpenKeys(newOpenKeys);
    };
    const renderMarkdown = (content, itemTitle, itemEntryTitle, itemParentTitle) => (React.createElement(AnalyticsAttributesProvider, { value: {
            eventColumn: itemTitle,
            eventContainer: type,
            labelEnglish: itemEntryTitle,
            parentLabel: itemParentTitle
        } },
        React.createElement(Markdown, null, content)));
    return appearance === 'Grid' ? (React.createElement(Row, null, items === null || items === void 0 ? void 0 : items.filter(({ type }) => type === 'uiAccordionItem').map(({ id, content: { entryTitle, title, ariaLabel, content } }) => (React.createElement(Column, { key: id, xs: { align: 'left' }, md: { span: '6' }, lg: { span: '4' } },
        React.createElement(GridItem, { "data-open": openKeys.includes(id), backgroundField: background },
            React.createElement("h3", null,
                React.createElement(AccordionButton, { "aria-expanded": openKeys.includes(id), "aria-label": ariaLabel, "data-testid": "grid-accordion-click", onClick: () => toggleOpenKeys(id, title, entryTitle, parentTitle) },
                    React.createElement("span", { "aria-hidden": "true" }, openKeys.includes(id) ? '-' : '+'),
                    title)),
            React.createElement(Expand, { show: openKeys.includes(id) },
                React.createElement(GridItemContent, null, renderMarkdown(content, title, entryTitle, parentTitle))))))))) : (React.createElement(List, null, items === null || items === void 0 ? void 0 : items.filter(({ type }) => type === 'uiAccordionItem').map(({ id, content: { entryTitle, title, ariaLabel, content } }, index) => (React.createElement(ListItem, { key: index, "data-open": openKeys.includes(id) },
        React.createElement("h3", null,
            React.createElement(AccordionButton, { "aria-expanded": openKeys.includes(id), "aria-label": ariaLabel, "data-testid": "list-accordion-click", onClick: () => toggleOpenKeys(id, title, entryTitle, parentTitle) },
                React.createElement("span", { "aria-hidden": "true" }, openKeys.includes(id) ? '-' : '+'),
                title)),
        React.createElement(Expand, { show: openKeys.includes(id) },
            React.createElement(ListItemContent, null, renderMarkdown(content, title, entryTitle, parentTitle))))))));
}
//# sourceMappingURL=UiAccordion.js.map